import { Input } from 'antd';

import { BaseFormFieldWrapper } from '../BaseFormFieldWrapper/BaseFormFieldWrapper';

const TextArea = Input.TextArea;

const BaseTextArea_ = (props) => {
  const { field, onBlur, handleChange, ...rest } = props;

  return <TextArea {...field} {...rest} onBlur={onBlur} onChange={(e) => handleChange(e.target.value)} />;
};

export const BaseTextArea = BaseFormFieldWrapper(BaseTextArea_);
export default BaseTextArea;
